import Component from './component';

export interface Props {
    html: String;
    className?: string;
}

Component.defaultProps = {
    className: null,
};

export default Component;